import React from 'react';
import NotFound from '../../NotFound';
import Prismic from 'prismic-javascript';
import {RichText} from 'prismic-reactjs';
import PrismicConfig from '../../prismic-configuration';
import HexaContainer from '../HexaContainer/HexaContainer'
import styles from './RandomQuote.scss';

export default class RandomQuote extends React.Component {

    state = {
        doc: null,
        notFound: false,
    }
        
    componentWillMount(){
        Prismic.api(PrismicConfig.apiEndpoint).then(api => {
            api.query(
                Prismic.Predicates.at('document.type', 'quote'),
            ).then(response => {
                if(response.results.length > 0){

                    const min = 1;
                    const max = response.results.length;
                    const randomNumber =  min + (Math.random() * (max-min));
                    const floorNumberToArrayLength = Math.round(randomNumber - 1);

                    this.setState({ doc: response.results[floorNumberToArrayLength] });
                } else{
                    this.setState({ notFound: true });
                }
            });
        });
    }
    
    render(){
        if (this.state.doc) {
            const document = this.state.doc;
            return (
                <div className={styles.quote} style={{backgroundImage: 'url("' + document.data.background_image.url + '")'}}>
                    <img className={'logo'} src="images/t_i_d_BLACK_web@4x.png" alt="logo" />
                    <h2>{RichText.asText(document.data.quote)}</h2>
                    <h3>{RichText.asText(document.data.written_by)}</h3>
                    <HexaContainer key={'desktop_empty_01'} type={'empty'} extraClass={styles.desktop_hexa_filler} />
                    <HexaContainer key={'desktop_empty_02'} type={'empty'} extraClass={styles.desktop_hexa_filler_second}/>
                </div>
            )
        } else if (this.state.notFound) {
            return <NotFound />;
        }
        return <h1>Loading</h1>;
    }
}


// WEBPACK FOOTER //
// ./src/Components/RandomQuote/RandomQuote.js